import { render } from "./BasicLink.vue?vue&type=template&id=b8b656de&scoped=true"
import script from "./BasicLink.vue?vue&type=script&lang=js"
export * from "./BasicLink.vue?vue&type=script&lang=js"

import "./BasicLink.vue?vue&type=style&index=0&id=b8b656de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b656de"]])

export default __exports__